import { Theme } from "@material-ui/core";

export const getTitleForCurrentTime = (name: string) => {
  const now = new Date(Date.now());
  const currentHour = now.getHours();

  let greeting;
  if (currentHour < 12) {
    greeting = "Good morning";
  } else if (currentHour < 18) {
    greeting = "Good afternoon";
  } else {
    greeting = "Good evening";
  }

  return `${greeting} ${name}`;
};

export const baseSettings = (theme: Theme) => ({
  layout: {
    display: "grid",
    gridTemplateColumns: "1fr",
    gridTemplateRows: "auto auto auto",
    gridGap: theme.spacing(5),
    width: "100%",
    margin: 0,

    [theme.breakpoints.up("sm")]: {
      gridTemplateColumns: "1fr",
      gridTemplateRows: "auto auto auto auto",
      gridGap: theme.spacing(3),
    },

    [theme.breakpoints.up("md")]: {
      gridTemplateColumns: "1fr 1fr",
      gridTemplateRows: "auto 1fr",
      gridGap: theme.spacing(3),
    },

    [theme.breakpoints.up("xl")]: {
      gridTemplateColumns: "1fr 1fr 1fr",
      gridTemplateRows: "1fr 1fr",
    },
  },
});

export const defaultCardStyles = (theme: Theme) => ({
  arrears: {},
  news: {
    gridArea: "3 / 1 / 4 / 2",

    [theme.breakpoints.up("sm")]: {
      gridArea: "1 / 1 / 2 / 2",
    },

    [theme.breakpoints.up("md")]: {
      gridArea: "1 / 1 / 3 / 2",
    },

    [theme.breakpoints.up("xl")]: {
      gridArea: "1 / 1 / 2 / 2",
    },
  },
  thingsToDo: {
    gridArea: "2 / 1 / 3 / 2",

    [theme.breakpoints.up("sm")]: {
      gridArea: "3 / 1 / 4 / 2",
    },

    [theme.breakpoints.up("md")]: {
      gridArea: "1 / 2 / 2 / 3",
    },

    [theme.breakpoints.up("xl")]: {
      gridArea: "1 / 2 / 2 / 3",
    },
  },
  calendar: {
    gridArea: "1 / 1 / 2 / 2",

    [theme.breakpoints.up("sm")]: {
      gridArea: "2 / 1 / 3 / 2",
    },

    [theme.breakpoints.up("md")]: {
      gridArea: "2 / 2 / 3 / 3",
    },

    [theme.breakpoints.up("xl")]: {
      gridArea: "1 / 3 / 2 / 4",
    },
  },
});

export const withArrearsCardStyles = (theme: Theme) => ({
  arrears: {
    gridArea: "1 / 1 / 2 / 2",

    [theme.breakpoints.up("sm")]: {
      gridArea: "1 / 1 / 2 / 2",
    },

    [theme.breakpoints.up("md")]: {
      gridArea: "1 / 1 / 2 / 2",
    },

    [theme.breakpoints.up("xl")]: {
      gridArea: "1 / 1 / 2 / 2",
    },
  },
  news: {
    gridArea: "2 / 1 / 3 / 2",

    [theme.breakpoints.up("sm")]: {
      gridArea: "2 / 1 / 3 / 2",
    },

    [theme.breakpoints.up("md")]: {
      gridArea: "2 / 1 / 3 / 2",
    },

    [theme.breakpoints.up("xl")]: {
      gridArea: "2 / 1 / 3 / 2",
    },
  },
  thingsToDo: {
    gridArea: "4 / 1 / 5 / 2",

    [theme.breakpoints.up("sm")]: {
      gridArea: "4 / 1 / 5 / 2",
    },

    [theme.breakpoints.up("md")]: {
      gridArea: "1 / 2 / 2 / 3",
    },

    [theme.breakpoints.up("xl")]: {
      gridArea: "1 / 2 / 2 / 3",
    },
  },
  calendar: {
    gridArea: "3 / 1 / 4 / 2",

    [theme.breakpoints.up("sm")]: {
      gridArea: "3 / 1 / 4 / 2",
    },

    [theme.breakpoints.up("md")]: {
      gridArea: "2 / 2 / 3 / 3",
    },

    [theme.breakpoints.up("xl")]: {
      gridArea: "1 / 3 / 2 / 4",
    },
  },
});
